import { createActionConst } from '../../../../utils/action.utils';

const MEETING_FOLDER_NAMESPACE = 'MEETING_FOLDER';

export const FETCH_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'FETCH_MEETING_FOLDER');

export const CREATE_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'CREATE_MEETING_FOLDER');
export const UPDATE_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'UPDATE_MEETING_FOLDER');
export const DELETE_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'DELETE_MEETING_FOLDER');

export const STORE_MEETING_FOLDER_IDS = createActionConst(MEETING_FOLDER_NAMESPACE, 'STORE_MEETING_FOLDER_IDS');
export const CLEAR_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'CLEAR_MEETING_FOLDER');
